import DefaultLayout from '../Layouts/DefaultLayout';

import HomeBanner from '../Components/HomeBanner';
import HomeBlog from '../Components/HomeBlog';
import HomeFeatureds from '../Components/HomeFeatureds';
import HomeInstagram from '../Components/HomeInstagram';
import HomeSlides from '../Components/HomeSlides';

function App() {
    return (
        <DefaultLayout>
            <div className="py-4 md:py-6 2xl:py-10">
                <div className="grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:gap-7.5">
                    <div className="col-span-12">
                        <HomeBanner />
                        <HomeFeatureds />
                        <HomeInstagram />
                        <HomeBlog />
                        <HomeSlides />
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
